import { makeStyles } from '@material-ui/core/styles';
const CARET_WIDTH = 7;
const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: CARET_WIDTH,
        overflow: 'visible',
        '&::before': {
            content: '""',
            borderWidth: CARET_WIDTH,
            borderStyle: 'solid',
            borderColor: 'transparent',
            position: 'absolute',
            borderBottomColor: 'white',
            bottom: '100%',
            right: 0,
            width: 0,
            height: 0,
            display: 'block',
            marginLeft: theme.space.margin.small,
            marginRight: theme.space.margin.small,
        },
        '&.bottom-center::before': {
            left: '50%',
            right: 'auto',
            marginLeft: -CARET_WIDTH,
            marginRight: 'auto',
        },
        '&.bottom-left::before': {
            left: 0,
            right: 'auto',
            marginLeft: theme.space.margin.small,
            marginRight: 'auto',
        },
    },
}));
export default useStyles;
//# sourceMappingURL=HeaderPopoverStyles.js.map